import { IOpData, IOpChangeState, ICopyable, IJsonSerializable } from '../util/interfaces'
import { Enums } from '../common/enums'

import { OpDataType } from '../core/op-data-type'


export class OpDeviceOrderNumberData
    implements
    ICopyable<OpDeviceOrderNumberData>,
    IJsonSerializable,
    IOpChangeState,
    IOpData {

    // #region Properties

    public idDeviceOrderNumberData: number
    public idDeviceOrderNumber: number
    public idDataType: number
    public indexNbr: number
    public value: any

    // #endregion

    // #region NavigationProperties

    private _dataType: OpDataType = null
    public get dataType(): OpDataType {
        return this._dataType
    }
    public set dataType(value: OpDataType) {
        this._dataType = value
        this.idDataType = value != null ? value.idDataType : null
    }

    // #endregion

    //#region Ctor

    constructor(opObj: any = null) {
        if (opObj instanceof OpDeviceOrderNumberData) {
            this.copy(<OpDeviceOrderNumberData>opObj, true, true, true, true)
        } else {
            this.fromJSON(opObj)
        }
    }

    //#endregion


    // #region IOpChangeState

    public opState: Enums.OpChangeState

    // #endregion


    // #region IOpData

    public get idData() { return this.idDeviceOrderNumberData }
    public set idData(idData: number) { this.idDeviceOrderNumberData = idData }
    public get indexNBR() { return this.indexNbr }
    public set indexNBR(indexNBR: number) { this.indexNbr = indexNBR }

    // #endregion


    //#endregion IJsonSerializable Implementation

    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj != null) {
            this.dataType = opObj._DataType != null ? new OpDataType(opObj._DataType) : null

            this.idDeviceOrderNumberData = opObj.ID_DEVICE_ORDER_NUMBER_DATA
            this.idDeviceOrderNumber = opObj.ID_DEVICE_ORDER_NUMBER
            this.idDataType = opObj.ID_DATA_TYPE
            this.indexNbr = opObj.INDEX_NBR
            this.value = opObj.VALUE
            this.opState = opObj.OpState
        }

    }

    public toJSON(compressed: boolean = false): any {
        return {
            ID_DEVICE_ORDER_NUMBER_DATA: this.idDeviceOrderNumberData,
            ID_DEVICE_ORDER_NUMBER: this.idDeviceOrderNumber,
            ID_DATA_TYPE: this.idDataType,
            INDEX_NBR: this.indexNbr,
            VALUE: this.value,
            OpState: this.opState
        }
    }

    // #endregion


    // #region ICopyable

    public clone(includeNavigationProperties: boolean, includeCustomProperties: boolean, includeDataList: boolean, includeDynamicValues: boolean): OpDeviceOrderNumberData {
        const data: OpDeviceOrderNumberData = new OpDeviceOrderNumberData(null)

        data.copy(this, includeNavigationProperties, includeCustomProperties, includeDataList, includeDynamicValues)

        return data
    }

    public copy(source: OpDeviceOrderNumberData, includeNavigationProperties: boolean, includeCustomProperties: boolean, includeDataList: boolean, includeDynamicValues: boolean): void {
        if (source == null) {
            return
        }

        if (includeNavigationProperties) {
            if (source.dataType != null) {
                this.dataType = source.dataType.clone(includeNavigationProperties, includeCustomProperties, includeDataList, includeDynamicValues)
            }
        }

        this.idDeviceOrderNumberData = source.idDeviceOrderNumberData
        this.idDeviceOrderNumber = source.idDeviceOrderNumber
        this.idDataType = source.idDataType
        this.indexNbr = source.indexNbr
        this.value = source.value
        this.opState = source.opState
    }

    // #endregion


    //#region fromIOpData

    public static fromIOpData(data: IOpData): OpDeviceOrderNumberData {
        const newData: OpDeviceOrderNumberData = new OpDeviceOrderNumberData()

        newData.idDeviceOrderNumberData = data.idData
        newData.idDataType = data.idDataType
        newData.indexNbr = data.indexNBR
        newData.value = data.value
        newData.opState = data.opState

        return newData
    }

    //#endregion
}